import React, { useState } from 'react';
import './DatePicker.scss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Controller } from 'react-hook-form';
import translations from '../../translations/de';

const Picker = ({
    label = '',
    name = '',
    selectText = '',
    error = false,
    control,
    disabled,
    defaultValue,
    onChange,
    withTime = false,
    timeOnly = false,
    dateOnly = false,
    isRequired = false,
    minDate,
}) => {
    const [date, setDate] = useState(dateIsValid(defaultValue) ? new Date(defaultValue) : '');

    const changeHandler = (date) => {
        onChange(name, date);
        setDate(date);
    };

    function dateIsValid(date) {
        return !Number.isNaN(new Date(date).getTime());
    }

    return (
        <div className="Date-Picker">
            <label>{label}</label>
            {control ? (
                <Controller
                    control={control}
                    name={name}
                    rules={{ required: isRequired }}
                    render={({ field: { onChange, value, name, ref } }) => (
                        <DatePicker
                            ref={ref}
                            name={name}
                            onChange={onChange}
                            selected={
                                value !== null ? (dateIsValid(value) ? new Date(value) : '') : ''
                            }
                            showMonthDropdown={!timeOnly}
                            showYearDropdown={!timeOnly}
                            dateFormat={
                                timeOnly ? 'HH:mm' : withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'
                            }
                            showTimeSelect={!dateOnly}
                            showTimeSelectOnly={timeOnly}
                            timeIntervals={15}
                            isClearable={!disabled}
                            disabled={disabled}
                            placeholderText={
                                !disabled ? selectText : timeOnly ? 'No Time' : 'No date selected'
                            }
                            minDate={!timeOnly ? minDate : null}
                            autoComplete="off"
                        />
                    )}
                />
            ) : (
                <DatePicker
                    name={name}
                    showMonthDropdown={!timeOnly}
                    showYearDropdown={!timeOnly}
                    placeholderText={!disabled ? selectText : 'No date selected'}
                    dateFormat={timeOnly ? 'HH:mm' : withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
                    selected={date}
                    isClearable={!disabled}
                    showTimeSelect={!dateOnly}
                    showTimeSelectOnly={timeOnly}
                    timeIntervals={15}
                    onChange={changeHandler}
                    disabled={disabled}
                    minDate={!timeOnly ? minDate : null}
                />
            )}
            <span className="error-msg">{error && <p>{translations.required}</p>}</span>
        </div>
    );
};

export default Picker;
